// ──────────────────────────────────────────────────────────────
// Special Moments — shared mock data
// No backend endpoints exist for this module yet. Every screen
// reads from this single file so cross-screen navigation (Inbox →
// Profile → Wish Composer) resolves to the same customer record.
// Swap this file's exports for real API calls once the backend
// (smGetTodaysCelebrations, smGetCustomerProfile, ...) exists.
// ──────────────────────────────────────────────────────────────

export const SM_DEMO_TODAY = '2026-07-25'

export const OCCASION_META = {
    birthday: { label: 'Birthday', emoji: '🎂' },
    anniversary: { label: 'Wedding Anniversary', emoji: '💍' },
    childBirthday: { label: "Child's Birthday", emoji: '🎈' },
    businessAnniversary: { label: 'Business Anniversary', emoji: '🏆' },
}

const initialsOf = (name) =>
    name
        .split(/[\s&]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase())
        .join('')

// Master customer records — the source of truth for the module.
export const SM_CUSTOMERS = [
    {
        identifier: 'cust_priya_sharma',
        name: 'Priya Sharma',
        occasion: 'birthday',
        occasionDate: '2026-07-25',
        turningAge: 29,
        isVIP: true,
        customerSince: 2021,
        lastVisitDaysAgo: 16,
        favoriteStylist: 'Riya',
        lifetimeSpend: 46300,
        visits: 18,
        phone: '+91 98200 11223',
        pastWishes: [
            { year: 2025, channel: 'SMS', status: 'sent' },
            { year: 2024, channel: 'WhatsApp', status: 'sent' },
            { year: 2023, channel: 'Called', status: 'sent' },
        ],
        status: 'pending',
    },
    {
        identifier: 'cust_rahul_verma',
        name: 'Rahul Verma',
        occasion: 'birthday',
        occasionDate: '2026-07-25',
        turningAge: 34,
        isVIP: false,
        customerSince: 2022,
        lastVisitDaysAgo: 9,
        favoriteStylist: 'Amit',
        lifetimeSpend: 18400,
        visits: 11,
        phone: '+91 98200 33445',
        pastWishes: [
            { year: 2025, channel: 'WhatsApp', status: 'sent' },
            { year: 2024, channel: 'WhatsApp', status: 'sent' },
        ],
        status: 'completed',
        completedVia: 'Wished via WhatsApp',
        completedAt: '9:12 AM',
    },
    {
        identifier: 'cust_amit_neha',
        name: 'Amit & Neha',
        occasion: 'anniversary',
        occasionDate: '2026-07-25',
        yearsTogether: 8,
        isVIP: false,
        customerSince: 2018,
        lastVisitDaysAgo: 11,
        favoriteStylist: 'Sonal',
        lifetimeSpend: 62150,
        visits: 27,
        phone: '+91 98200 55667',
        pastWishes: [
            { year: 2025, channel: 'WhatsApp', status: 'sent' },
            { year: 2024, channel: 'Called', status: 'sent' },
        ],
        status: 'pending',
    },
    {
        identifier: 'cust_neha_kapoor',
        name: 'Neha Kapoor',
        occasion: 'anniversary',
        occasionDate: '2026-07-25',
        yearsTogether: 3,
        isVIP: false,
        customerSince: 2023,
        lastVisitDaysAgo: 20,
        favoriteStylist: 'Riya',
        lifetimeSpend: 9200,
        visits: 5,
        phone: '+91 98200 66778',
        pastWishes: [{ year: 2025, channel: 'Called', status: 'sent' }],
        status: 'completed',
        completedVia: 'Called by Reception',
        completedAt: '10:05 AM',
    },
    {
        identifier: 'cust_meera_iyer',
        name: 'Meera Iyer',
        occasion: 'birthday',
        occasionDate: '2026-07-25',
        turningAge: 41,
        isVIP: true,
        customerSince: 2019,
        lastVisitDaysAgo: 5,
        favoriteStylist: 'Amit',
        lifetimeSpend: 88400,
        visits: 42,
        phone: '+91 98200 77889',
        pastWishes: [
            { year: 2025, channel: 'Gift Coupon', status: 'sent' },
            { year: 2024, channel: 'WhatsApp', status: 'sent' },
        ],
        status: 'completed',
        completedVia: 'Gift coupon sent',
        completedAt: '11:41 AM',
    },
    {
        identifier: 'cust_arjun_das',
        name: 'Arjun Das',
        occasion: 'birthday',
        occasionDate: '2026-07-25',
        turningAge: 26,
        isVIP: false,
        customerSince: 2024,
        lastVisitDaysAgo: 33,
        favoriteStylist: 'Sonal',
        lifetimeSpend: 5400,
        visits: 3,
        phone: '+91 98200 88990',
        pastWishes: [],
        status: 'pending',
    },
    {
        identifier: 'cust_kavya_reddy',
        name: 'Kavya Reddy',
        occasion: 'childBirthday',
        occasionDate: '2026-07-25',
        turningAge: 6,
        isVIP: false,
        customerSince: 2020,
        lastVisitDaysAgo: 14,
        favoriteStylist: 'Riya',
        lifetimeSpend: 22100,
        visits: 15,
        phone: '+91 98200 99001',
        pastWishes: [{ year: 2025, channel: 'WhatsApp', status: 'sent' }],
        status: 'completed',
        completedVia: 'Wished via WhatsApp',
        completedAt: '1:20 PM',
    },
    {
        identifier: 'cust_saloni_studio',
        name: 'Saloni Beauty Studio Franchise',
        occasion: 'businessAnniversary',
        occasionDate: '2026-07-25',
        yearsTogether: 2,
        isVIP: true,
        customerSince: 2024,
        lastVisitDaysAgo: 40,
        favoriteStylist: 'Riya',
        lifetimeSpend: 152000,
        visits: 60,
        phone: '+91 98200 10011',
        pastWishes: [{ year: 2025, channel: 'Called', status: 'sent' }],
        status: 'pending',
    },
]

export const SM_CUSTOMERS_BY_ID = SM_CUSTOMERS.reduce((acc, c) => {
    acc[c.identifier] = { ...c, initials: initialsOf(c.name) }
    return acc
}, {})

export const getCustomer = (identifier) => SM_CUSTOMERS_BY_ID[identifier] || null

export const SM_RECENTLY_MISSED = [
    { identifier: 'cust_dev_malhotra', name: 'Dev Malhotra', occasion: 'birthday', missedDaysAgo: 2 },
    { identifier: 'cust_ritika_shah', name: 'Ritika Shah', occasion: 'anniversary', missedDaysAgo: 3 },
    { identifier: 'cust_omkar_joshi', name: 'Omkar Joshi', occasion: 'birthday', missedDaysAgo: 4 },
    { identifier: 'cust_farah_khan', name: 'Farah Khan', occasion: 'birthday', missedDaysAgo: 5 },
    { identifier: 'cust_vivek_nair', name: 'Vivek Nair', occasion: 'businessAnniversary', missedDaysAgo: 6 },
]

export const SM_SUMMARY = {
    today: { birthdays: 6, anniversaries: 2, total: 8 },
    week: { birthdays: 18, anniversaries: 6, total: 24 },
    month: { birthdays: 82, anniversaries: 23, total: 105 },
}

// Calendar counts for July 2026 — day-of-month → occasion counts.
export const SM_CALENDAR_JULY_2026 = {
    2: { birthday: 2 },
    5: { birthday: 1 },
    8: { anniversary: 1 },
    11: { birthday: 3 },
    14: { anniversary: 1, birthday: 1 },
    16: { birthday: 2 },
    18: { anniversary: 2, birthday: 1 },
    20: { birthday: 1 },
    22: { anniversary: 1 },
    25: { birthday: 6, anniversary: 2 },
    28: { birthday: 2, anniversary: 1 },
    30: { birthday: 1 },
}

export const SM_CALENDAR_DAY_DETAILS = {
    25: SM_CUSTOMERS.map(({ identifier, name, occasion }) => ({ identifier, name, occasion })),
}

export const SM_TEMPLATES = [
    {
        identifier: 'tpl_birthday',
        name: 'Birthday',
        occasion: 'birthday',
        body: 'Hi {{firstName}},\n\nHappy Birthday! 🎉\n\nThank you for being a wonderful customer for the last {{yearsAsCustomer}} years.\n\nHave an amazing year ahead!',
        usageCount: 214,
    },
    {
        identifier: 'tpl_birthday_coupon',
        name: 'Birthday with Coupon',
        occasion: 'birthday',
        body: 'Hi {{firstName}},\n\nHappy Birthday! 🎂 As a small token of appreciation, here is a flat ₹500 coupon valid for your next visit.\n\nSee you soon!',
        usageCount: 96,
    },
    {
        identifier: 'tpl_birthday_premium',
        name: 'Birthday Premium',
        occasion: 'birthday',
        body: 'Dear {{firstName}},\n\nWishing you a birthday filled with joy and pampering ✨. As one of our most valued clients, please enjoy a complimentary hair spa on us this month.',
        usageCount: 41,
    },
    {
        identifier: 'tpl_anniversary',
        name: 'Wedding Anniversary',
        occasion: 'anniversary',
        body: 'Hi {{firstName}},\n\nHappy Anniversary to you both! 💍 {{yearsTogether}} years together is truly something to celebrate.\n\nWishing you many more years of love and laughter.',
        usageCount: 58,
    },
    {
        identifier: 'tpl_business_anniversary',
        name: 'Business Anniversary',
        occasion: 'businessAnniversary',
        body: 'Dear {{firstName}},\n\nCongratulations on {{yearsTogether}} years in business! 🏆 It has been a pleasure being your salon partner.',
        usageCount: 12,
    },
    {
        identifier: 'tpl_child_birthday',
        name: 'Child Birthday',
        occasion: 'childBirthday',
        body: "Hi {{firstName}},\n\nHappy Birthday to your little one! 🎈 We'd love to pamper them with a free kids' styling session this week.",
        usageCount: 33,
    },
    {
        identifier: 'tpl_festival',
        name: 'Festival Style',
        occasion: 'birthday',
        body: 'Hi {{firstName}},\n\nHappy Birthday! May this festive season bring you double the celebration. 🎊',
        usageCount: 19,
    },
]

export const SM_HISTORY = {
    today: { count: 6, label: 'Today' },
    yesterday: { count: 3, label: 'Yesterday' },
    month: { count: 48, label: 'July' },
    wishRate: 92,
    neverWished: 12,
    recent: [
        { identifier: 'cust_rahul_verma', name: 'Rahul Verma', occasion: 'birthday', via: 'Wished via WhatsApp', at: 'Today, 9:12 AM' },
        { identifier: 'cust_neha_kapoor', name: 'Neha Kapoor', occasion: 'anniversary', via: 'Called by Reception', at: 'Today, 10:05 AM' },
        { identifier: 'cust_meera_iyer', name: 'Meera Iyer', occasion: 'birthday', via: 'Gift coupon sent', at: 'Today, 11:41 AM' },
        { identifier: 'cust_kavya_reddy', name: 'Kavya Reddy', occasion: 'childBirthday', via: 'Wished via WhatsApp', at: 'Today, 1:20 PM' },
        { identifier: 'cust_dev_malhotra', name: 'Dev Malhotra', occasion: 'birthday', via: 'SMS sent', at: 'Yesterday, 6:40 PM' },
    ],
}

export const SM_ANALYTICS = {
    customersCelebrated: 428,
    wishRate: 94,
    birthdayWishes: 362,
    anniversaryWishes: 66,
    mostActiveMonth: 'December',
    missedCelebrations: 14,
}

export const SM_DEFAULT_SETTINGS = {
    occasionsEnabled: {
        birthday: true,
        anniversary: true,
        businessAnniversary: true,
        childBirthday: true,
    },
    notificationTime: '09:00',
    reminders: {
        today: true,
        oneDayBefore: true,
        oneWeekBefore: true,
    },
    defaultSender: 'Salon WhatsApp',
}
